import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { trackingEvent } from '../../../../../helpers/tracking';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderSelect from '../../../../../common/components/render-input/select';
import logger from '../../../../../helpers/logger';

export const formName = Routes.STEPFIVE;

const tracking = {
    eventAction: 'Mortgage Calculator - Step 5',
    eventLabel: 'Your Payment Frequency'
};

const validate = values => v(values, {
    amortizationPeriod: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const minValue = 2;
const maxValue = 25;

const amortizationPeriodOptions = Array.from(
    new Array((maxValue - minValue) + 1).fill(minValue),
    (value, i) => value + i
)
    .reduce((values, label) => ({
        ...values,
        [label]: label
    }), {});

class StepFiveForm extends Component {
    componentDidMount() {
        logger.logUserAction('form_step_loaded', 'MortgageCalculator-Step5', {
            step: 5,
            formName: formName,
            url: window.location.href
        });
    }

    componentDidUpdate(prevProps) {
        // Log validation errors
        if (this.props.invalid && this.props.submitFailed && this.props.syncErrors) {
            logger.warn('Form validation failed in Step 5', {
                step: 5,
                formName: formName,
                errors: this.props.syncErrors,
                values: this.props.values
            });
        }
    }

    render() {
        return (
            <form className={styles.form}>
                <Field
                    name='amortizationPeriod'
                    label='When do you want to be mortgage free?'
                    prefix='Years'
                    options={amortizationPeriodOptions}
                    component={RenderSelect}
                    onChange={(event, newValue, previousValue) => {
                        if (newValue !== previousValue) {
                            logger.logUserAction('field_changed', 'MortgageCalculator-Step5', {
                                step: 5,
                                field: 'amortizationPeriod',
                                previousValue,
                                newValue
                            });
                        }
                    }}
                />
            </form>
        );
    }
}

// Enhanced onSubmit with logging
const enhancedOnSubmit = async (values, dispatch, props) => {
    try {
        const result = await onSubmit(values, dispatch, props);
        logger.logFormSubmission('MortgageCalculator-Step5', values, true);
        return result;
    } catch (error) {
        logger.error('Step 5 form submission failed', {
            step: 5,
            formName: formName,
            values,
            error: error.message || error
        });
        throw error;
    }
};

StepFiveForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit: enhancedOnSubmit,
    initialValues: {
        amortizationPeriod: maxValue
    },
    redirectPath: `/mortgage${Routes.STEPSIX}`,
    tracking: () => trackingEvent(tracking)
})(StepFiveForm);

export default withRouter(StepFiveForm);
